import styled from "styled-components";
import React, { useEffect, useRef, useState } from "react";
import {MdOutlineExpandMore} from "react-icons/md";

const Container = styled.div`
 
   button{
       border: none;
       background: none;
       display: flex;
       width: 100%;
       justify-content: center;
       align-items: center;
       padding: 5px;
   }
   .up{
       svg{
           transform: rotate(180deg);
       }
       &.none{
           opacity: 0;
       }
   } 
   svg{
       width: 24px;
       height: 24px;
       path{
        
           color: #333!important;
       }
   } 
`

const List = styled.ul`
    list-style-type: none;
    margin: 0;
    padding:0 5px;
    overflow: hidden;
    width: 100%;
    height: 150px;
    overflow-y: scroll;
    position: relative;
    &::-webkit-scrollbar {
        width: 0px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: rgba(51, 51, 51, 0.3);
        border: none;
        border-radius: 4px;
    }
    &::-webkit-scrollbar-track {
        background-color: transparent;
        border: none;
    }
`;

const ListCenter = styled.div<{height:number}>`
    transition: all 0.25s;
    box-sizing: border-box;
    //border-top: 1.3px solid black;
    //border-bottom: 1.3px solid black;
    height: 75px;
    position: sticky;
    top: 0px;
    padding-bottom: 50px;
`;

const ListItem = styled.li<{ isSelected: boolean }>`
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    border-radius: 6px;
    opacity: ${({isSelected}) => (isSelected ? 1 : 0.3)};
    background:${({isSelected}) => (isSelected ? "rgba(245, 245, 245, 0.7)": "none")} ;
    span {
        font-size: 14px;
        transition: all 0.15s;
        transform: scale(${({isSelected}) => (isSelected ? 1.5 : 1)});
        
    }
`;

interface ScrollPickerProps {
    list: (string | number)[];
    onSelectedChange?: (selected: string | number) => void;
}

const Picker = ({ list, onSelectedChange }: ScrollPickerProps) => {
    const SCROLL_DEBOUNCE_TIME = 100;
    const SCROLL_INCREMENT = 5; // 더 빠른 스크롤을 위해 이 값을 증가시킴

    const newList = ["", ...list, ""];
    const ref = useRef<HTMLUListElement>(null);
    const [selected, setSelected] = useState(1);
    const itemRefs = useRef<(HTMLLIElement | null)[]>([]);
    const timerRef = useRef<NodeJS.Timeout | null>(null);
    const [scrolling, setScrolling] = useState(false); // 스크롤 중 여부를 추적하는 상태
    const ITEM_HEIGHT = 30;

    const handleScroll = () => {
        if (!scrolling && ref.current) {
            clearTimeout(timerRef.current!);
            if (ref.current.scrollTop < ITEM_HEIGHT) {
                ref.current.scrollTop = ITEM_HEIGHT;
            }
            timerRef.current = setTimeout(() => {
                const index = Math.floor(
                    (ref.current!.scrollTop + ITEM_HEIGHT / 2) / ITEM_HEIGHT
                );
                if (list[index] !== "") {
                    setSelected(index);
                    onSelectedChange && onSelectedChange(newList[index]);
                }
            }, SCROLL_DEBOUNCE_TIME);
        }
    };
    
    console.log("@selected",selected);
    const handleItemClick = (index: number) => {
        setSelected(index);
        smoothScroll(ref.current!, index * ITEM_HEIGHT, 80);
        onSelectedChange && onSelectedChange(newList[index]);
    };

    useEffect(() => {
        if (ref.current) {
            // 리스트가 다섯 개씩 보이도록 가운데 아이템을 중앙에 위치시키기
            // 예를 들어, 리스트의 길이가 충분하다면 중앙의 아이템에 해당하는 스크롤 위치로 초기 설정
            const initialScrollPosition = ITEM_HEIGHT * 2 - (150 / 2); // 리스트 전체가 중앙에 표시되도록 계산
            ref.current.scrollTop = initialScrollPosition;
        }
    }, []);

    // 부드러운 스크롤 효과를 위한 함수
    const smoothScroll = (element: HTMLElement, to: number, duration: number) => {
        const start = element.scrollTop;
        const change = to - start;
        let currentTime = 0;

        const animateScroll = () => {
            currentTime += SCROLL_INCREMENT;
            const val = easeInOutQuad(currentTime, start, change, duration);
            element.scrollTop = val;
            if (currentTime <= duration) { // 마지막 위치까지 이동 가능하도록 수정
                requestAnimationFrame(animateScroll);
            } else {
                setScrolling(false); // 스크롤 완료 후 상태 변경
            }
        };
        animateScroll();
    };

    // easing 함수
    const easeInOutQuad = (t: number, b: number, c: number, d: number) => {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
    };

    // 마우스 다운 이벤트 핸들러
    const validIndexRange = [1, list.length]; // newList는 ["", ...list, ""] 형태이므로

    const handleMouseDown = (direction: "up" | "down") => {
        if (!ref.current) return;
        setScrolling(true);

        let nextSelected = direction === "up" ? selected - 1 : selected + 1;
        if (nextSelected >= 1 && nextSelected <= list.length) {
            smoothScroll(ref.current!, nextSelected * ITEM_HEIGHT, 50);
            setSelected(nextSelected);
        }

        const intervalId = setInterval(() => {
            nextSelected = direction === "up" ? nextSelected - 1 : nextSelected + 1;
            smoothScroll(ref.current!, nextSelected * ITEM_HEIGHT, 50);
            if (nextSelected >= 1 && nextSelected <= list.length) {
                setSelected(nextSelected);
            } else {
                clearInterval(intervalId);
                setScrolling(false);
            }

        }, 120); // 100ms 간격으로 반복

        const handleMouseUp = () => {
            clearInterval(intervalId); // 마우스를 떼면 반복 호출 중단
            setScrolling(false);
            window.removeEventListener("mouseup", handleMouseUp);
        };

        // 마우스 업 이벤트 리스너를 추가하여 사용자가 마우스 버튼을 떼면 handleMouseUp 함수가 호출되도록 함
        window.addEventListener("mouseup", handleMouseUp);
    };

    const easeInOutCubic = (t) => {
        return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    };


    const smoothScrollBy = (target, amount) => {
        const startTime = performance.now();
        const startScrollTop = target.scrollTop;
        const duration = 100; // 애니메이션 지속 시간(ms)

        const scroll = (currentTime) => {
            const elapsedTime = currentTime - startTime;
            const progress = Math.min(elapsedTime / duration, 1); // 진행률 (0에서 1 사이)

            const nextScrollTop = startScrollTop + amount * easeInOutCubic(progress);

            target.scrollTop = nextScrollTop;

            if (elapsedTime < duration) {
                requestAnimationFrame(scroll);
            }
        };

        requestAnimationFrame(scroll);
    };

    const handleWheel = (event) => {
        event.preventDefault(); // 기본 스크롤 동작 방지
        const element = event.currentTarget; // 스크롤 대상 요소
        const to = element.scrollTop + (event.deltaY > 0 ? ITEM_HEIGHT : -ITEM_HEIGHT);
        smoothScroll(element, to, 50);
    };

    return (
        <Container style={{width:"100%"}}>
            <button className={`up ${selected === 1 ? "none" : ""}`} onMouseDown={() => handleMouseDown("up")}>
                <MdOutlineExpandMore />
            </button>
            <List ref={ref} onScroll={handleScroll} onWheel={handleWheel} className={"Picker"}>
                <ListCenter height={250 / 2}/>
                {newList.map((item, index) => (
                    <ListItem
                        key={index}
                        isSelected={index === selected}
                        ref={(el) => (itemRefs.current[index] = el)}
                        onClick={() => handleItemClick(index)}
                    >
                        <span>
                        {item}
                        </span>
                    </ListItem>
                ))}
            </List>
            <button onMouseDown={() => handleMouseDown("down")}>
                <MdOutlineExpandMore />

            </button>
        </Container>
    );
};

export default Picker;
